"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundOffToTwoPlaces = exports.replaceEmailsInString = exports.removeDuplicates = exports.pushHomeState = exports.parseJson = exports.parseBrTags = exports.overwriteDataInList = exports.modifyDataLabelsUsingFunction = exports.merge = exports.mapGoogleUserToResponse = exports.listDataIndex = exports.linkDecorator = exports.isURL = exports.isStringEndsWith = exports.isStringContainsEmail = exports.isString = exports.isNumeric = exports.isNotEmptyString = exports.isListContainsData = exports.isHeaderLeftTabs = exports.isEmptyString = exports.isEmail = exports.hasProperty = exports.getValueFromQueryParam = exports.getUserIdsFromMentionString = exports.getStringFromEmphasizedString = exports.getSelectedTeam = exports.getNameFromEmail = exports.getMonthName = exports.getMinifiedText = exports.getHomeRedirectPath = exports.getDateObjectFromString = exports.getCurrentHomePath = exports.getCircularProgressColorMapping = exports.getAbsoluteHomePath = exports.filterListByEitherOfTwoParams = exports.filterList = exports.downloadCSVFile = exports.deleteFromList = exports.delay = exports["default"] = exports.dataURItoBlob = exports.createStringToMarkup = exports.createQueryString = exports.createMarkupString = exports.convertTimeToString = exports.convertStringToNewLineComponent = exports.convertStringToMentions = exports.convertStringToKey = exports.convertPercentLabelToFilterValues = exports.convertNumberToCommaStringFormat = exports.convertNumberStringToPercentageString = exports.convertMentionsToStringForEdit = exports.convertMentionsToString = exports.convertHexToRGBA = exports.convertEmphasizedStringToBoldOrHighlightComponent = exports.convertDateToString = exports.convertDateStringToValueArray = exports.compareValues = exports.compareLists = exports.clone = exports.capitalizeString = exports.calcPercentageRange = exports.areSameObjects = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _lib = _interopRequireDefault(require("@xto10x/storage/lib"));
var _moment = require("./moment.util");
var _validator = require("./validator.util");
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */

var appUtils = {
  downloadCSVFile: function downloadCSVFile(data, filename, mimetype) {
    if (!data) return;
    var blob = data.constructor !== Blob ? new Blob([data], {
      type: mimetype || 'application/octet-stream'
    }) : data;
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
      return;
    }
    var lnk = document.createElement('a');
    var url = window.URL;
    var objectURL;
    if (mimetype) {
      lnk.type = mimetype;
    }
    lnk.download = filename || 'untitled';
    // eslint-disable-next-line no-multi-assign
    lnk.href = objectURL = url.createObjectURL(blob);
    lnk.dispatchEvent(new MouseEvent('click'));
    setTimeout(url.revokeObjectURL.bind(url, objectURL));
  },
  delay: function delay() {
    var millisecond = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
    return new Promise(function (res) {
      return setTimeout(res, millisecond);
    });
  },
  clone: function clone(data) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (shallow) return Object.assign(type, data);
    return JSON.parse(JSON.stringify(data));
  },
  isString: function isString(obj) {
    return obj != null && (typeof obj === 'string' || obj instanceof String);
  },
  isStringEndsWith: function isStringEndsWith(str, suffixes) {
    if (appUtils.isEmptyString(str) || suffixes == null) return false;
    for (var i = 0; i < suffixes.length; i += 1) {
      if (str.endsWith(suffixes[i])) return true;
    }
    return false;
  },
  isStringContainsEmail: function isStringContainsEmail(str) {
    return appUtils.isNotEmptyString(str) && str.search(/([^.@\s]+)(\.[^.@\s]+)*@([^.@\s]+\.)+([^.@\s]+)/) !== -1;
  },
  replaceEmailsInString: function replaceEmailsInString(str, replaceWith) {
    if (appUtils.isStringContainsEmail(replaceWith)) replaceWith = '';
    var shouldReplace = appUtils.isNotEmptyString(str) && appUtils.isStringContainsEmail(str);
    while (shouldReplace) {
      str = str.replace(/([^.@\s]+)(\.[^.@\s]+)*@([^.@\s]+\.)+([^.@\s]+)/, replaceWith || '');
      shouldReplace = appUtils.isNotEmptyString(str) && appUtils.isStringContainsEmail(str);
    }
    return str;
  },
  roundOffToTwoPlaces: function roundOffToTwoPlaces(number) {
    if (typeof number !== 'number') return 0;
    return Math.round((number + Number.EPSILON) * 100) / 100;
  },
  parseBrTags: function parseBrTags(string) {
    var _string, _string2;
    var data = [];
    /* this has been segregated to a separate function
      to avoid redundancy of the same code
    */
    var parser = function parser(text) {
      var splittedString = text.split(/<br \/>/g);
      var i = 0;
      for (i = 0; i < splittedString.length - 1; i++) {
        data.push(splittedString[i]);
        data.push(/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: appUtils.convertStringToKey("break".concat(i))
        }, /*#__PURE__*/_react["default"].createElement("br", null)));
      }
      data.push(splittedString[i]);
      return data;
    };
    if (typeof string === 'string' && (_string = string) !== null && _string !== void 0 && _string.includes('<br />')) {
      return parser(string);
    }
    /* parseBrTags is called on results from convertEmphasizedStringToBoldOrHighlightComponent,
      which would have replaced the b tags with react fragments and would have returned an array
    */
    if ((0, _typeof2["default"])(string) === 'object' && (_string2 = string) !== null && _string2 !== void 0 && _string2.length) string = string.map(function (text) {
      if (typeof text === 'string') {
        return parser(text);
      }
      return text;
    });
    return string;
  },
  convertEmphasizedStringToBoldOrHighlightComponent: function convertEmphasizedStringToBoldOrHighlightComponent(string, startTag, endTag, type) {
    if (appUtils.isEmptyString(string) || appUtils.isEmptyString(startTag) || appUtils.isEmptyString(endTag)) return string;
    return string.toString().split(startTag).map(function (startSplitText) {
      if (startSplitText.includes(endTag)) {
        return startSplitText.split(endTag).map(function (endStringText, index) {
          if (index === 0) {
            return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
              key: appUtils.convertStringToKey("".concat(endStringText).concat(index))
            }, type === 'MENTION' ? /*#__PURE__*/_react["default"].createElement("span", {
              className: "userMentions"
            }, " ", endStringText, " ") : type === 'STRONG' ? /*#__PURE__*/_react["default"].createElement("b", null, endStringText) : /*#__PURE__*/_react["default"].createElement("em", null, endStringText));
          }
          return endStringText;
        });
      }
      return startSplitText;
    });
  },
  getStringFromEmphasizedString: function getStringFromEmphasizedString(srcString) {
    var startTag = '<em>';
    var endTag = '</em>';
    if (appUtils.isEmptyString(srcString) || appUtils.isEmptyString(startTag) || appUtils.isEmptyString(endTag)) return srcString;
    var finalArray = srcString.toString().split(startTag).map(function (startSplitText) {
      if (startSplitText.includes(endTag)) {
        return startSplitText.split(endTag).map(function (endStringText) {
          return endStringText;
        }).join('');
      }
      return startSplitText;
    });
    return finalArray.join('');
  },
  convertStringToNewLineComponent: function convertStringToNewLineComponent(srcString) {
    var containsUserMentions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var shouldTrim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (appUtils.isEmptyString(srcString)) return srcString;
    var mentionStartTag = "<span class='userMentions'>";
    var mentionEndTag = '</span>';
    var highlightStartTag = '<em>';
    var highlightEndTag = '</em>';
    var finalString = srcString.toString();
    if (shouldTrim) finalString = finalString.trim();
    return finalString.split('\n').map(function (text, index) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: appUtils.convertStringToKey("".concat(text).concat(index))
      }, containsUserMentions && text.includes(mentionStartTag) && text.includes(mentionEndTag) ? appUtils.convertEmphasizedStringToBoldOrHighlightComponent(text, mentionStartTag, mentionEndTag, 'MENTION') : text.includes(highlightStartTag) && text.includes(highlightEndTag) ? appUtils.convertEmphasizedStringToBoldOrHighlightComponent(text, highlightStartTag, highlightEndTag, 'HIGHLIGHT') : text, /*#__PURE__*/_react["default"].createElement("br", null));
    });
  },
  convertStringToKey: function convertStringToKey(srcString) {
    if (appUtils.isEmptyString(srcString)) return srcString;
    return srcString.trim().toLowerCase().replace(/[^a-zA-Z_]/g, '_');
  },
  parseJson: function parseJson(jsonString) {
    if (appUtils.isEmptyString(jsonString)) return jsonString;
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      return jsonString;
    }
  },
  hasProperty: function hasProperty(obj, property) {
    return obj != null && Object.prototype.hasOwnProperty.call(obj, property);
  },
  areSameObjects: function areSameObjects(obj1, obj2) {
    var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (properties == null) return JSON.stringify(obj1) === JSON.stringify(obj2);
    if (properties != null && obj1 != null && obj2 != null) {
      var hasSameProperties = true;
      properties.forEach(function (property) {
        if (!appUtils.hasProperty(obj1, property) || !appUtils.hasProperty(obj1, property) || JSON.stringify(obj1[property]) !== JSON.stringify(obj2[property])) {
          hasSameProperties = false;
        }
      });
      return hasSameProperties;
    }
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  },
  merge: function merge(target) {
    for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      sources[_key - 1] = arguments[_key];
    }
    return Object.assign(target, sources);
  },
  filterList: function filterList(dataList, key) {
    var filterKeyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return dataList.filter(function (item) {
      return item[key].toLowerCase().includes(filterKeyword.toLowerCase());
    });
  },
  filterListByEitherOfTwoParams: function filterListByEitherOfTwoParams(dataList, key1, key2) {
    var filterKeyword = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    return dataList.filter(function (item) {
      return item[key1] && item[key1].toLowerCase().includes(filterKeyword.toLowerCase()) || item[key2] && item[key2].toLowerCase().includes(filterKeyword.toLowerCase());
    });
  },
  compareValues: function compareValues(key) {
    var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';
    return function (a, b) {
      if (appUtils.hasProperty(a, key) && !appUtils.hasProperty(b, key)) {
        // property does exist in a but not in b, bring a to top
        return -1;
      }
      if (!appUtils.hasProperty(a, key) && appUtils.hasProperty(b, key)) {
        // property does exist in b but not in a, bring b to top
        return 1;
      }
      if (!appUtils.hasProperty(a, key) && !appUtils.hasProperty(b, key)) {
        // property doesn't exist on either object
        return 0;
      }
      if (a[key] === b[key]) {
        return 0;
      }
      var varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
      var varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];
      var comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return order === 'desc' ? comparison * -1 : comparison;
    };
  },
  dataURItoBlob: function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);else byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], {
      type: mimeString
    });
  },
  compareLists: function compareLists(dataList1, dataList2, key) {
    if (dataList1 == null && dataList2 == null) {
      return true;
    }
    if (dataList1 != null && dataList2 == null || dataList1 == null && dataList2 != null || dataList1.length !== dataList2.length) {
      return false;
    }
    var sortedList1 = appUtils.clone(dataList1, []).sort(appUtils.compareValues(key));
    var sortedList2 = appUtils.clone(dataList2, []).sort(appUtils.compareValues(key));
    for (var index = 0; index < sortedList1.length; index += 1) {
      if (sortedList1[index][key] !== sortedList2[index][key]) {
        return false;
      }
    }
    return true;
  },
  overwriteDataInList: function overwriteDataInList(dataList, key, data) {
    var dataListClone = appUtils.clone(dataList, []);
    var index = dataListClone.findIndex(function (item) {
      return item[key] === data[key];
    });
    dataListClone.splice(index, 1, data);
    return dataListClone;
  },
  isListContainsData: function isListContainsData(dataList, key, value) {
    return dataList && dataList.findIndex(function (item) {
      return item[key] === value;
    }) > -1;
  },
  listDataIndex: function listDataIndex(dataList, key, value) {
    return dataList ? dataList.findIndex(function (item) {
      return item[key] === value;
    }) : -1;
  },
  removeDuplicates: function removeDuplicates(dataList, key) {
    return dataList.filter(function (obj, pos, arr) {
      return arr.map(function (mObj) {
        return mObj[key];
      }).indexOf(obj[key]) === pos;
    });
  },
  deleteFromList: function deleteFromList(list, key, value) {
    return list.filter(function (obj) {
      return obj[key] !== value;
    });
  },
  capitalizeString: function capitalizeString(str) {
    if (str == null || str.trim().length === 0) return str;
    return str[0].toUpperCase() + str.slice(1);
  },
  createMarkupString: function createMarkupString(text) {
    var temp = text;
    // eslint-disable-next-line no-useless-escape
    var urlRegex = /(http:\/\/www\.|https:\/\/|www\.|http:\/\/|https:\/\/)\b(?:[a-z\d])(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))?/g;
    if (text.match(urlRegex)) {
      temp = text.replace(urlRegex, function (url) {
        var tempUrl = url;
        if (!url.includes('http')) {
          tempUrl = "http://".concat(url);
        }
        return "<a href=\"".concat(tempUrl, "\" target=\"_blank\">").concat(url, "</a>");
      });
    }
    return temp.replace(/\r?\n/g, '<br />');
  },
  createStringToMarkup: function createStringToMarkup(value) {
    var tempMessage = value;
    if (value.match(/(target="_blank">)/g)) {
      var url = '';
      var lastIndexOfMention = 0;
      var startIndexOfName = '';
      var endIndexOfName = '';

      // eslint-disable-next-line no-useless-escape
      var count = value.match(/(target="_blank">)/g).length;
      if (count > 0) {
        for (var i = 0; i < count; i += 1) {
          startIndexOfName = value.indexOf('target="_blank">', lastIndexOfMention) + 4;
          endIndexOfName = value.indexOf('</a>', startIndexOfName);
          url = value.slice(startIndexOfName, endIndexOfName);
          lastIndexOfMention = endIndexOfName;
          tempMessage = tempMessage.replace("<a href=\"".concat(url, "\" target=\"_blank\">").concat(url, "</a>"), "".concat(url));
        }
      }
    }
    return tempMessage;
  },
  convertMentionsToStringForEdit: function convertMentionsToStringForEdit(value, data) {
    var tempMessage = value;
    tempMessage = appUtils.convertMentionsToString(tempMessage);
    // eslint-disable-next-line no-useless-escape
    var count = tempMessage && tempMessage.match(/(@)/g) && tempMessage.match(/(@)/g).length;
    if (count > 0) {
      for (var i = 0; i < count; i += 1) {
        var listOfKeys = Object.keys(data.tagged_users);
        for (var j = 0; j < listOfKeys.length; j += 1) {
          if (data.tagged_users && data.tagged_users[listOfKeys[j]] && data.tagged_users[listOfKeys[j]].name) {
            tempMessage = tempMessage.replace("@".concat(data.tagged_users[listOfKeys[j]].name), "//~".concat(data.tagged_users[listOfKeys[j]].user_reference_id, "~//"));
          }
        }
      }
    }
    return tempMessage;
  },
  getUserIdsFromMentionString: function getUserIdsFromMentionString(value) {
    var userIdsArray = [];
    // eslint-disable-next-line no-useless-escape
    if (value.match(/(\/\/\~\[)/g)) {
      var lastIndexOfMention = 0;
      var startIndexOfName = '';
      var endIndexOfName = '';
      var startIndexOfId = '';
      var endIndexOfId = '';

      // eslint-disable-next-line no-useless-escape
      var count = value.match(/(\/\/\~\[)/g).length;
      if (count > 0) {
        for (var i = 0; i < count; i += 1) {
          startIndexOfName = value.indexOf('//~[', lastIndexOfMention) + 4;
          endIndexOfName = value.indexOf('](', startIndexOfName);
          startIndexOfId = value.indexOf('](', endIndexOfName) + 2;
          endIndexOfId = value.indexOf(')~//', startIndexOfId);
          userIdsArray.push(value.slice(startIndexOfId, endIndexOfId));
          lastIndexOfMention = endIndexOfId;
        }
      }
    }
    return userIdsArray;
  },
  convertMentionsToString: function convertMentionsToString(value) {
    var tempMessage = value;
    // eslint-disable-next-line no-useless-escape
    if (value.match(/(\/\/\~\[)/g)) {
      var obj = {};
      var lastIndexOfMention = 0;
      var startIndexOfName = '';
      var endIndexOfName = '';
      var startIndexOfId = '';
      var endIndexOfId = '';

      // eslint-disable-next-line no-useless-escape
      var count = value.match(/(\/\/\~\[)/g).length;
      if (count > 0) {
        for (var i = 0; i < count; i += 1) {
          startIndexOfName = value.indexOf('//~[', lastIndexOfMention) + 4;
          endIndexOfName = value.indexOf('](', startIndexOfName);
          startIndexOfId = value.indexOf('](', endIndexOfName) + 2;
          endIndexOfId = value.indexOf(')~//', startIndexOfId);
          obj.name = value.slice(startIndexOfName, endIndexOfName);
          obj.id = value.slice(startIndexOfId, endIndexOfId);
          lastIndexOfMention = endIndexOfId;
          tempMessage = tempMessage.replace("//~[".concat(obj.name, "](").concat(obj.id, ")~//"), "//~".concat(obj.id, "~//"));
        }
      }
    }
    return tempMessage;
  },
  convertStringToMentions: function convertStringToMentions(data, type) {
    var tempMessage = data.message;
    // eslint-disable-next-line no-useless-escape
    var count = data && data.message && data.message.match(/(\/\/~)/g) && data.message.match(/(\/\/~)/g).length;
    if (count > 0) {
      for (var i = 0; i < count; i += 1) {
        var listOfKeys = Object.keys(data.tagged_users);
        for (var j = 0; j < listOfKeys.length; j += 1) {
          if (data.tagged_users && data.tagged_users[listOfKeys[j]] && data.tagged_users[listOfKeys[j]].name && type !== 'edit' && type !== 'edit_comment' && type !== 'reply_comment') {
            tempMessage = tempMessage.replace("//~".concat(listOfKeys[j], "~//"), "<span class='userMentions'>@".concat(data.tagged_users[listOfKeys[j]].name, "</span>"));
          } else if (type === 'edit' || type === 'reply_comment') {
            tempMessage = tempMessage.replace("//~".concat(listOfKeys[j], "~//"), "@".concat(data.tagged_users[listOfKeys[j]].name));
          } else if (type === 'edit_comment') {
            tempMessage = tempMessage.replace("//~".concat(listOfKeys[j], "~//"), "//~[".concat(data.tagged_users[listOfKeys[j]].name, "](").concat(data.tagged_users[listOfKeys[j]].user_reference_id, ")~//"));
          }
        }
      }
    }
    return tempMessage;
  },
  getValueFromQueryParam: function getValueFromQueryParam(key) {
    return new URLSearchParams(window.location.search).get(key);
  },
  convertHexToRGBA: function convertHexToRGBA(hex, opacity) {
    var h = hex.replace('#', '');
    h = h.match(new RegExp("(.{".concat(h.length / 3, "})"), 'g'));
    for (var i = 0; i < h.length; i += 1) h[i] = parseInt(h[i].length === 1 ? h[i] + h[i] : h[i], 16);
    if (typeof opacity !== 'undefined') h.push(opacity);
    return "rgba(".concat(h.join(','), ")");
  },
  getSelectedTeam: function getSelectedTeam() {
    var teams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var selectedTeamId = arguments.length > 1 ? arguments[1] : undefined;
    if (selectedTeamId) {
      if (selectedTeamId === _constants.HeaderLeftTabs[1].tag_id) {
        return _constants.HeaderLeftTabs[1];
      }
      if (selectedTeamId === _constants.HeaderLeftTabs[2].tag_id) {
        return _constants.HeaderLeftTabs[2];
      }
      for (var i = 0; i <= teams.length; i += 1) {
        if (teams[i] && selectedTeamId === teams[i].tag_id) {
          return teams[i];
        }
      }
    }
    return _constants.HeaderLeftTabs[0];
  },
  isHeaderLeftTabs: function isHeaderLeftTabs(tag_id) {
    return tag_id == null || tag_id === _constants.HeaderLeftTabs[0].tag_id || tag_id === _constants.HeaderLeftTabs[1].tag_id || tag_id === _constants.HeaderLeftTabs[2].tag_id;
  },
  isEmptyString: function isEmptyString(str) {
    return str == null || (0, _validator.isEmpty)(str.toString().trim());
  },
  isNotEmptyString: function isNotEmptyString(str) {
    return !appUtils.isEmptyString(str);
  },
  isEmail: function isEmail(str) {
    return appUtils.isNotEmptyString(str) && (0, _validator.isEmail)(str.trim());
  },
  getNameFromEmail: function getNameFromEmail(str) {
    if (str == null) return str;
    return appUtils.capitalizeString(str.toString().trim().split('@')[0].split('.')[0].split('_')[0]);
  },
  isURL: function isURL(str) {
    return appUtils.isNotEmptyString(str) && (0, _validator.isURL)(str);
  },
  isNumeric: function isNumeric(str) {
    return appUtils.isNotEmptyString(str) && (0, _validator.isNumeric)(str);
  },
  convertTimeToString: function convertTimeToString(timestamp) {
    var conversionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DateConversionType.HOUR_AND_DATE;
    var prefix = arguments.length > 2 ? arguments[2] : undefined;
    if (!timestamp) {
      return '';
    }
    var timestampDate = new Date(timestamp);
    var currentDate = new Date();

    // get seconds
    var seconds = Math.abs(currentDate - timestampDate) / 1000;
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var completeCurrentDate = "".concat(currentDate.getDate(), " / ").concat(currentDate.getMonth() + 1, " / ").concat(currentDate.getFullYear());
    var completeTimeStampDate = "".concat(timestampDate.getDate(), " / ").concat(timestampDate.getMonth() + 1, " / ").concat(timestampDate.getFullYear());
    if (conversionType === _constants.DateConversionType.HOUR_AND_DATE) {
      if (hours < 24 && completeCurrentDate === completeTimeStampDate) {
        return "at ".concat((0, _moment.format_date)(timestampDate, 'hh$:$mm$ $a'));
      }
      if (hours <= 24 && timestampDate.getDate() === currentDate.getDate() - 1 || hours > 24 && hours < 48) {
        return "".concat(prefix ? "".concat(prefix, " ") : '', "yesterday");
      }
      // rest all case returning this value
      return "".concat(prefix ? prefix : 'on', " ").concat((0, _moment.format_date)(timestampDate, 'Do$ $MMM'));
    }
    return (0, _moment.toFromNow)(timestampDate);
  },
  mapGoogleUserToResponse: function mapGoogleUserToResponse(res) {
    var authResponse = res.getAuthResponse();
    var basicProfile = res.getBasicProfile();
    res.googleId = basicProfile.getId();
    res.tokenObj = authResponse;
    res.tokenId = authResponse.id_token;
    res.accessToken = authResponse.access_token;
    res.profileObj = {
      googleId: basicProfile.getId(),
      imageUrl: basicProfile.getImageUrl(),
      email: basicProfile.getEmail(),
      name: basicProfile.getName(),
      givenName: basicProfile.getGivenName(),
      familyName: basicProfile.getFamilyName()
    };
    return res;
  },
  calcPercentageRange: function calcPercentageRange(value, limit) {
    if (value * 100 / limit >= 0 && value * 100 / limit <= 30) {
      return _constants.wordLimit.ZERO;
    }
    if (value * 100 / limit > 30 && value * 100 / limit <= 70) {
      return _constants.wordLimit.LOW;
    }
    if (value * 100 / limit > 70 && value * 100 / limit < 100) {
      return _constants.wordLimit.MEDIUM;
    }
    if (value * 100 / limit === 100) {
      return _constants.wordLimit.FULL;
    }
    return _constants.wordLimit.OVER;
  },
  getMonthName: function getMonthName(monthIndex) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[monthIndex];
  },
  getDateObjectFromString: function getDateObjectFromString(date) {
    if (!date) return null;
    return new Date(date);
  },
  convertDateToString: function convertDateToString(dateObj) {
    if (!dateObj) return null;
    var date = dateObj.getDate();
    date = date < 10 ? "0".concat(date) : date;
    var year = dateObj.getYear() + 1900;
    var month = dateObj.getMonth() + 1;
    month = month < 10 ? "0".concat(month) : month;
    return "".concat(year, "-").concat(month, "-").concat(date);
  },
  convertDateStringToValueArray: function convertDateStringToValueArray(dateString) {
    var zeroIndexingMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // convert 2017-03-11 to [2017,2,11]
    if (/[0-9]+-[0-9]+-[0-9]+/.test(dateString)) {
      var valueArray = dateString.split('-').map(function (dateElement) {
        return parseInt(dateElement, 10);
      });
      if (!zeroIndexingMonth) valueArray[1] -= 1;
      return valueArray;
    }
    return [dateString];
  },
  getMinifiedText: function getMinifiedText(text, requiredLength) {
    var maxVisibleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
    if ((text.length <= requiredLength || appUtils.isEmptyString(text)) && text.split(/\r?\n/g).length <= maxVisibleLines) return text;
    var index = requiredLength;
    while (text[index] !== ' ' && index <= text.length) {
      index += 1;
    }
    var finalText = index < text.length - 40 ? text.substring(0, index) : text;
    var differentLines = finalText.split(/\r?\n/g);
    if (differentLines.length > maxVisibleLines) finalText = differentLines.slice(0, maxVisibleLines).join('\n');
    return "".concat(finalText, "...");
  },
  linkDecorator: function linkDecorator(href, text, key) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      key: key,
      target: "_blank",
      rel: "noopener noreferrer"
    }, text);
  },
  modifyDataLabelsUsingFunction: function modifyDataLabelsUsingFunction(data, customizingFunction) {
    var cloneData = appUtils.clone(data);
    cloneData.labels = cloneData.labels.map(function (label) {
      return customizingFunction(label);
    });
    return cloneData;
  },
  getCircularProgressColorMapping: function getCircularProgressColorMapping(colorArray) {
    var inverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var numberOfSteps = 4;
    var stepSize = 100 / numberOfSteps; // make it more reusable by passing max value and number of steps, currenetly its 100 and 4
    var finalColorMapping = [];
    for (var i = 0; i < numberOfSteps; i += 1) {
      finalColorMapping.push({
        from: i === 0 ? 0 : stepSize * i + 1,
        to: stepSize * (i + 1),
        color: inverse ? colorArray[colorArray.length - 1 - i] : colorArray[i]
      });
    }
    return finalColorMapping;
  },
  convertNumberStringToPercentageString: function convertNumberStringToPercentageString(numberString) {
    if (/[0-9]+-[0-9]+/.test(numberString)) {
      var _numberString$split = numberString.split('-'),
        _numberString$split2 = (0, _slicedToArray2["default"])(_numberString$split, 2),
        startValue = _numberString$split2[0],
        endValue = _numberString$split2[1];
      return "".concat(startValue, "-").concat(endValue, "%");
    }
    if (/> [0-9+]/.test(numberString)) {
      var greaterThanValue = numberString.split('> ')[1];
      return "More than ".concat(greaterThanValue, "%");
    }
    if (/< [0-9+]/.test(numberString)) {
      var lessThanValue = numberString.split('< ')[1];
      return "Less than ".concat(lessThanValue, "%");
    }
    return '';
  },
  convertPercentLabelToFilterValues: function convertPercentLabelToFilterValues(value) {
    if (value.startsWith('Less than')) {
      var percentValue = value.split(' ')[2];
      return [null, percentValue.substring(0, percentValue.length - 1)];
    }
    if (value.startsWith('More than')) {
      var _percentValue = value.split(' ')[2];
      return [_percentValue.substring(0, _percentValue.length - 1), null];
    }
    return value.substring(0, value.length - 1).split('-');
  },
  convertNumberToCommaStringFormat: function convertNumberToCommaStringFormat(number) {
    if (number || number === 0) {
      var string = '';
      var stringArr = number.toString().split('.');
      if (stringArr[0]) string += stringArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (stringArr[1]) string += ".".concat(stringArr[1]);
      return string;
    }
    return '';
  }
};
var _default = exports["default"] = appUtils;
var convertDateStringToValueArray = exports.convertDateStringToValueArray = function convertDateStringToValueArray(dateString) {
  var zeroIndexingMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return appUtils.convertDateStringToValueArray(dateString, zeroIndexingMonth);
};
var delay = exports.delay = function delay(millisecond) {
  return appUtils.delay(millisecond);
};
var downloadCSVFile = exports.downloadCSVFile = function downloadCSVFile(data, filename, mimetype) {
  return appUtils.downloadCSVFile(data, filename, mimetype);
};
var clone = exports.clone = function clone(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return appUtils.clone(data, type, shallow);
};
var convertStringToNewLineComponent = exports.convertStringToNewLineComponent = function convertStringToNewLineComponent(srcString) {
  var containsUserMentions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var shouldTrim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return appUtils.convertStringToNewLineComponent(srcString, containsUserMentions, shouldTrim);
};
var convertStringToKey = exports.convertStringToKey = function convertStringToKey(srcString) {
  return appUtils.convertStringToKey(srcString);
};
var parseJson = exports.parseJson = function parseJson(jsonString) {
  return appUtils.parseJson(jsonString);
};
var isString = exports.isString = function isString(obj) {
  return appUtils.isString(obj);
};
var isStringEndsWith = exports.isStringEndsWith = function isStringEndsWith(str, suffixes) {
  return appUtils.isStringEndsWith(str, suffixes);
};
var isStringContainsEmail = exports.isStringContainsEmail = function isStringContainsEmail(str) {
  return appUtils.isStringContainsEmail(str);
};
var replaceEmailsInString = exports.replaceEmailsInString = function replaceEmailsInString(str, replaceWith) {
  return appUtils.replaceEmailsInString(str, replaceWith);
};
var roundOffToTwoPlaces = exports.roundOffToTwoPlaces = function roundOffToTwoPlaces(number) {
  return appUtils.roundOffToTwoPlaces(number);
};
var merge = exports.merge = function merge(target) {
  for (var _len2 = arguments.length, sources = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    sources[_key2 - 1] = arguments[_key2];
  }
  return appUtils.merge(target, sources);
};
var hasProperty = exports.hasProperty = function hasProperty(obj, property) {
  return appUtils.hasProperty(obj, property);
};
var areSameObjects = exports.areSameObjects = function areSameObjects(obj1, obj2) {
  var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return appUtils.areSameObjects(obj1, obj2, properties);
};
var filterList = exports.filterList = function filterList(dataList, key) {
  var filterKeyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return appUtils.filterList(dataList, key, filterKeyword);
};
var deleteFromList = exports.deleteFromList = function deleteFromList(dataList, attribute, keyword) {
  return appUtils.deleteFromList(dataList, attribute, keyword);
};
var compareValues = exports.compareValues = function compareValues(key, order) {
  return appUtils.compareValues(key, order);
};
var removeDuplicates = exports.removeDuplicates = function removeDuplicates(dataList, key) {
  return appUtils.removeDuplicates(dataList, key);
};
var dataURItoBlob = exports.dataURItoBlob = function dataURItoBlob(dataURI) {
  return appUtils.dataURItoBlob(dataURI);
};
var compareLists = exports.compareLists = function compareLists(dataList1, dataList2, key) {
  return appUtils.compareLists(dataList1, dataList2, key);
};
var capitalizeString = exports.capitalizeString = function capitalizeString(str) {
  return appUtils.capitalizeString(str);
};
var createMarkupString = exports.createMarkupString = function createMarkupString(text) {
  return appUtils.createMarkupString(text);
};
var createStringToMarkup = exports.createStringToMarkup = function createStringToMarkup(text) {
  return appUtils.createStringToMarkup(text);
};
var convertMentionsToString = exports.convertMentionsToString = function convertMentionsToString(value) {
  return appUtils.convertMentionsToString(value);
};
var convertStringToMentions = exports.convertStringToMentions = function convertStringToMentions(data, type) {
  return appUtils.convertStringToMentions(data, type);
};
var convertMentionsToStringForEdit = exports.convertMentionsToStringForEdit = function convertMentionsToStringForEdit(value, data) {
  return appUtils.convertMentionsToStringForEdit(value, data);
};
var overwriteDataInList = exports.overwriteDataInList = function overwriteDataInList(dataList, key, data) {
  return appUtils.overwriteDataInList(dataList, key, data);
};
var isListContainsData = exports.isListContainsData = function isListContainsData(dataList, key, value) {
  return appUtils.isListContainsData(dataList, key, value);
};
var listDataIndex = exports.listDataIndex = function listDataIndex(dataList, key, value) {
  return appUtils.listDataIndex(dataList, key, value);
};
var getValueFromQueryParam = exports.getValueFromQueryParam = function getValueFromQueryParam(key) {
  return appUtils.getValueFromQueryParam(key);
};
var convertHexToRGBA = exports.convertHexToRGBA = function convertHexToRGBA(hex, opacity) {
  return appUtils.convertHexToRGBA(hex, opacity);
};
var getSelectedTeam = exports.getSelectedTeam = function getSelectedTeam(teams, selectedTeamId) {
  return appUtils.getSelectedTeam(teams, selectedTeamId);
};
var isHeaderLeftTabs = exports.isHeaderLeftTabs = function isHeaderLeftTabs(tag_id) {
  return appUtils.isHeaderLeftTabs(tag_id);
};
var isEmptyString = exports.isEmptyString = function isEmptyString(str) {
  return appUtils.isEmptyString(str);
};
var isNotEmptyString = exports.isNotEmptyString = function isNotEmptyString(str) {
  return appUtils.isNotEmptyString(str);
};
var isEmail = exports.isEmail = function isEmail(str) {
  return appUtils.isEmail(str);
};
var getNameFromEmail = exports.getNameFromEmail = function getNameFromEmail(str) {
  return appUtils.getNameFromEmail(str);
};
var isURL = exports.isURL = function isURL(str) {
  return appUtils.isURL(str);
};
var isNumeric = exports.isNumeric = function isNumeric(str) {
  return appUtils.isNumeric(str);
};
var convertTimeToString = exports.convertTimeToString = function convertTimeToString(timestamp, conversionType, prefix) {
  return appUtils.convertTimeToString(timestamp, conversionType, prefix);
};
var createQueryString = exports.createQueryString = function createQueryString() {
  var searchParams = new URLSearchParams(window.location.search);
  for (var i = 0; i < arguments.length; i += 1) {
    var query = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (query.value) searchParams.set(query.key, query.value);
  }
  return searchParams.toString();
};
var getCurrentHomePath = exports.getCurrentHomePath = function getCurrentHomePath() {
  var _storage$getDataFromL;
  var searchParams = new URLSearchParams(window.location.search);
  for (var i = 0; i < arguments.length; i += 1) {
    var query = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (query.value) searchParams.set(query.key, query.value);
  }
  var queryParam = searchParams.toString();
  var sub_domain = (_storage$getDataFromL = _lib["default"].getDataFromLocal(_constants.StorageKey.ORG_INFO)) === null || _storage$getDataFromL === void 0 ? void 0 : _storage$getDataFromL.sub_domain;
  return isNotEmptyString(queryParam) ? "/".concat(sub_domain, "/home?").concat(queryParam) : "/".concat(sub_domain, "/home");
};
var getAbsoluteHomePath = exports.getAbsoluteHomePath = function getAbsoluteHomePath() {
  var _storage$getDataFromL2;
  var absolutePathSearchQuery = new URLSearchParams('');
  for (var i = 0; i < arguments.length; i += 1) {
    var query = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (query.value) absolutePathSearchQuery.set(query.key, query.value);
  }
  var queryParam = absolutePathSearchQuery.toString();
  var sub_domain = (_storage$getDataFromL2 = _lib["default"].getDataFromLocal(_constants.StorageKey.ORG_INFO)) === null || _storage$getDataFromL2 === void 0 ? void 0 : _storage$getDataFromL2.sub_domain;
  return isNotEmptyString(queryParam) ? "/".concat(sub_domain, "/home?").concat(queryParam) : "/".concat(sub_domain, "/home");
};
var getHomeRedirectPath = exports.getHomeRedirectPath = function getHomeRedirectPath() {
  var redirectPath = _lib["default"].getDataFromLocal(_constants.StorageKey.REDIRECT_URL);
  _lib["default"].removeDataFromLocal(_constants.StorageKey.REDIRECT_URL);
  return isNotEmptyString(redirectPath) ? redirectPath : getCurrentHomePath();
};
var pushHomeState = exports.pushHomeState = function pushHomeState(homeQueryParam) {
  var _storage$getDataFromL3;
  var shouldReplace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var historyReactRouter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var searchParams = new URLSearchParams(window.location.search);
  if (searchParams.toString() === homeQueryParam) return;
  var sub_domain = (_storage$getDataFromL3 = _lib["default"].getDataFromLocal(_constants.StorageKey.ORG_INFO)) === null || _storage$getDataFromL3 === void 0 ? void 0 : _storage$getDataFromL3.sub_domain;
  var homePathWithQuery = isNotEmptyString(homeQueryParam) ? "/".concat(sub_domain, "/home?").concat(homeQueryParam) : "/".concat(sub_domain, "/home");
  if (shouldReplace) {
    if (!historyReactRouter) window.location.replace(homePathWithQuery);else historyReactRouter.replace({
      pathname: "/".concat(sub_domain, "/home"),
      search: homeQueryParam
    });
  } else if (!historyReactRouter) window.history.pushState('', '', homePathWithQuery);else historyReactRouter.push({
    pathname: "/".concat(sub_domain, "/home"),
    search: homeQueryParam
  });
};
var mapGoogleUserToResponse = exports.mapGoogleUserToResponse = function mapGoogleUserToResponse(res) {
  return appUtils.mapGoogleUserToResponse(res);
};
var calcPercentageRange = exports.calcPercentageRange = function calcPercentageRange(value, limit) {
  return appUtils.calcPercentageRange(value, limit);
};
var getMonthName = exports.getMonthName = function getMonthName(monthIndex) {
  return appUtils.getMonthName(monthIndex);
};
var getDateObjectFromString = exports.getDateObjectFromString = function getDateObjectFromString(dateArray) {
  return appUtils.getDateObjectFromString(dateArray);
};
var convertDateToString = exports.convertDateToString = function convertDateToString(dateObj) {
  return appUtils.convertDateToString(dateObj);
};
var getUserIdsFromMentionString = exports.getUserIdsFromMentionString = function getUserIdsFromMentionString(text) {
  return appUtils.getUserIdsFromMentionString(text);
};
var linkDecorator = exports.linkDecorator = function linkDecorator(href, text, key) {
  return appUtils.linkDecorator(href, text, key);
};
var getMinifiedText = exports.getMinifiedText = function getMinifiedText(text, requiredLength) {
  return appUtils.getMinifiedText(text, requiredLength);
};
var filterListByEitherOfTwoParams = exports.filterListByEitherOfTwoParams = function filterListByEitherOfTwoParams(dataList, key1, key2) {
  var keyword = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return appUtils.filterListByEitherOfTwoParams(dataList, key1, key2, keyword);
};
var getStringFromEmphasizedString = exports.getStringFromEmphasizedString = function getStringFromEmphasizedString(srcString) {
  return appUtils.getStringFromEmphasizedString(srcString);
};
var modifyDataLabelsUsingFunction = exports.modifyDataLabelsUsingFunction = function modifyDataLabelsUsingFunction(data, customizingFunction) {
  return appUtils.modifyDataLabelsUsingFunction(data, customizingFunction);
};
var getCircularProgressColorMapping = exports.getCircularProgressColorMapping = function getCircularProgressColorMapping(colorArray, inverse) {
  return appUtils.getCircularProgressColorMapping(colorArray, inverse);
};
var convertNumberStringToPercentageString = exports.convertNumberStringToPercentageString = function convertNumberStringToPercentageString(numberString) {
  return appUtils.convertNumberStringToPercentageString(numberString);
};
var convertPercentLabelToFilterValues = exports.convertPercentLabelToFilterValues = function convertPercentLabelToFilterValues(value) {
  return appUtils.convertPercentLabelToFilterValues(value);
};
var convertNumberToCommaStringFormat = exports.convertNumberToCommaStringFormat = function convertNumberToCommaStringFormat(number) {
  return appUtils.convertNumberToCommaStringFormat(number);
};
var parseBrTags = exports.parseBrTags = function parseBrTags(text) {
  return appUtils.parseBrTags(text);
};
var convertEmphasizedStringToBoldOrHighlightComponent = exports.convertEmphasizedStringToBoldOrHighlightComponent = function convertEmphasizedStringToBoldOrHighlightComponent(text, startTag, endTag, type) {
  return appUtils.convertEmphasizedStringToBoldOrHighlightComponent(text, startTag, endTag, type);
};